import {
  workspace_v1_AdminConfig,
  workspaceV1PutAdminConfigMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useUpdateAdminConfig = () => {
  const { workspace } = useWorkspace();
  return useMutation({
    mutationFn: (data: workspace_v1_AdminConfig) =>
      workspaceV1PutAdminConfigMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: data, path: { workspace } }),
  });
};
